'use client'
import { useState, useEffect } from 'react'

// Components
import BlurImage from '@/components/shared/blur-image'
import { HomeLandingText } from '@/app/[lang]/(home)/_components/landing/landing-text'

// Utils
import { cn } from '@/lib/utils'
import { placeholderBlurhash } from '@/lib/utils'

// Types
import type { Locale } from '@/i18n-config'
import type { Dictionary } from '@/types/global'

export function HomeLanding({
  lang,
  dictionary,
}: {
  lang: Locale
  dictionary: Dictionary
}) {
  // Add state for scroll offset
  const [offsetY, setOffsetY] = useState(0)

  useEffect(() => {
    const handleScroll = () => setOffsetY(window.scrollY)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <section id="landing" className="relative h-screen overflow-hidden">
      <div
        className="pointer-events-none z-0"
        style={{ transform: `translateY(${offsetY * 0.5}px)` }} // Adjust factor as needed
      >
        <BlurImage
          src="/assets/images/home/landing-6.png"
          alt="Landing image"
          width={1920}
          height={1080}
          priority={true}
          placeholder="blur"
          className="h-screen w-full object-cover "
          blurDataURL={placeholderBlurhash}
        />
      </div>

      <div className="absolute inset-0 flex items-center justify-center bg-black/20">
        <HomeLandingText lang={lang} />
      </div>

      {/* <div className="relative z-20">
   
        <div className="absolute bottom-3">
          <Campaign />
        </div>
      </div> */}
    </section>
  )
}
